<div class="fulfillmentLanding oti-wrapper">
  <div class="commandCenterLandingPage">
    <div class="row headerSection">
      <div class="col-6 p-0 pl-2 ml-xl-4 ">
        <h2 class="mb-0">
          EVOLVE <span>COMMAND CENTER</span>
        </h2>
      </div>
      <div class="col-4 p-0 d-flex align-items-center justify-content-xl-center justify-content-end ml-3 dateTimeSection ">
        <p class="mb-0 text-uppercase">
          {{ formattedDate }}
        </p>
      </div>
    </div>
    <div class="form-sec" [ngStyle]="{'display': showMessageCenterFullView || showKnowledgeCenterFullView ? 'none' : 'block'}">


      <div class="row tabletView">
        <!--Message center-->
        <div class="leftSection margin-t10 d-xl-table-cell d-flex">
          <div class="messageCenter">
            <div class="" *ngIf="!messageCenterMessages?.length && !messageCenterMessages?.length">
              <h2 class="text-center">
                Message Center
              </h2>
              <div class="icon text-center">
                <i class="fa fa-sharp fa-regular fa-inbox"></i>
              </div>
              <div class="textMessage">
                <h4 class="text-center">Nothing to see here!</h4>
                <p class="text-center changeFont">
                  You have no messages.
                  When you do, this is where
                  you'll find them.
                </p>
              </div>
            </div>
            <div *ngIf="messageCenterMessages?.length" class="messageSection">
              <h5 class="">Message Center</h5>
              <div class="accordSec">
                <mat-accordion>
                  <mat-expansion-panel (opened)="message.isPanelOpen = true" (closed)="message.isPanelOpen = false"
                                       *ngFor="let message of messageCenterMessages; let i = index" hideToggle="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="padding-l0 mb-0 d-inline-block col-10" style="font-size: 14px">
                          <button class="btn btn-link btn-block text-left collapsed" [ngClass]="message.isRead ? '':'unReadMessage'" type="button" (click)="readMessage(message);" data-toggle="collapse" data-target="#messageCenterMessages" aria-expanded="false" aria-controls="messageCenterMessages">
                            <div>
                              {{ message.title.length > 20 ? (message.title | slice:0:20) + '...' : message.title }}
                            </div>

                            <div *ngIf="!message.isPanelOpen">
                              {{ message.message.length > 20 ? (message.message | slice:0:20) + '...' : message.message }}
                            </div>
                            <div>
                              {{getFormattedMessageDate(message.updateTimestamp)}}
                            </div>
                            <span></span>
                          </button>
                        </div>
                        <div class="col-2" (click)="$event.stopPropagation();">
                          <div class="row">
                            <span class="col-3 text-center" *ngIf="!message.isPinned" (click)="pinUnPinMessage(message, true)"> <span class="pinUnchecked"></span></span>
                            <span class="col-3 text-center" *ngIf="message.isPinned" (click)="pinUnPinMessage(message, false)"> <span class="pinChecked"></span></span>
                          </div>

                        </div>

                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p [innerHTML]="message.formattedMessage | htmlSanitize" class="mb-0 padding-t10 updateFontFamily" style="font-size:16px;white-space: pre-wrap;  word-wrap: break-word;"></p>
                  </mat-expansion-panel>

                </mat-accordion>
              </div>
              <div class="viewAllBtn" *ngIf="messageCenterMessages?.length > 0">
                <a (click)="showFullMessageCenter()" style="cursor: pointer;">VIEW ALL</a>
              </div>
            </div>
            
          </div>

          <!--knowledge Center-->
          <div class="knowledgeCenter">
            <div class="col-12 m-auto">
              <h5 class="text-left">
                KNOWLEDGE CENTER
              </h5>
            </div>
            <div class="col-11 m-auto">
              <div class="input-group withButton">
                <input type="text"  [(ngModel)]="searchKeyword" class="form-control" style="color: white;" placeholder="Topics" aria-describedby="addon">
                <span class="input-group-addon" style="cursor:pointer;" id="addon"><button (click)="searchKnowledge()" [disabled]="searchKeyword?.length < 3">Search</button></span>
              </div>
            </div>
            <div class="knowledgeSection col-12 px-0 m-auto" >

              <ul >
                <li *ngFor="let knowledge of knowledgeCenterMessages | slice:0:4; let i = index" class="d-flex align-items-center"><span style="width: 90%;">{{knowledge.documentTitle}}</span> <span class="d-flex justify-content-end"><img [src]="knowledge.iconUrl"  (click)="openUrl(knowledge.documentUrl)"    class="circle-img" alt="circle-img" /></span></li>
              </ul>
            </div>
            <div class="col-12 viewAllBtn" >
              <a (click)="showFullKnowledgeCenter()" style="cursor: pointer;">VIEW ALL</a>
            </div>
          </div>

        </div>

        <div class="rightSection d-table-cell">
          <app-oti-home-grid-view (dataLoadComplete)="otiDataLoad($event)"></app-oti-home-grid-view>
        </div>
      </div>

    </div>
    <div class="form-sec" [ngStyle]="{'display': showMessageCenterFullView && !showKnowledgeCenterFullView? 'block' : 'none'}">
      <app-cc-message-center [messageCenterMessages]="messageCenterMessages" (backToHomeClicked)="backToHome()" (readMessageClicked)="readMessage($event)" (pinnedMessageClicked)="messagePinOnChildComp($event)"></app-cc-message-center>
    </div>
    <div class="form-sec" [ngStyle]="{'display': showKnowledgeCenterFullView && !showMessageCenterFullView ? 'block' : 'none'}">
      <app-cc-knowledge-center [parentSearchKeyword] ="searchKeyword" [knowledgeCenterMessages]="knowledgeCenterMessages" (backToHomeClicked)="backToHomeFrmKnow()" (searchClicked)="searchChildComp($event)"></app-cc-knowledge-center>
    </div>
  </div>
</div>
